import { AuditLogEvent } from '@seapoint/server/enums';
import { toast } from 'sonner';
import { exhaustiveCheck } from '../../utils/exhaustive-check';

type HandleAuditLogEventArgs = {
  type: AuditLogEvent;
  message: string;
  isError: boolean;
};

export const handleAuditLogEvent = ({ type, message, isError }: HandleAuditLogEventArgs) => {
  switch (type) {
    case AuditLogEvent.ACCOUNT_AND_TRANSACTION_SYNC:
    case AuditLogEvent.AI_PIPELINE:
      if (isError) {
        toast.error(message);

        return;
      }

      toast.info(message);

      return;
    case AuditLogEvent.ACCOUNT_STATE_CHANGE:
    case AuditLogEvent.ACCOUNT_BALANCE_CHANGE:
    case AuditLogEvent.PAYMENT_AUTHORISATION:
    case AuditLogEvent.PAYMENT_CALLBACK:
    case AuditLogEvent.PAYMENT_STATUS_CHANGE:
    case AuditLogEvent.PAYMENT_EXTERNAL_LINKED:
    case AuditLogEvent.INVOICE_READER:
    case AuditLogEvent.INVOICE_PAID_CHANGED:
    case AuditLogEvent.INVOICE_SYNCED_TO_ACCOUNTING:
    case AuditLogEvent.INVOICE_SYNC_STATE_CHANGE:
    case AuditLogEvent.OAUTH_AUTHORIZATION_FAILED:
    case AuditLogEvent.OAUTH_AUTHORIZATION_SUCCEEDED:
    case AuditLogEvent.OAUTH_CALLBACK_FAILED:
    case AuditLogEvent.OAUTH_CALLBACK_SUCCEEDED:
    case AuditLogEvent.OAUTH_CONNECTION_FAILED:
    case AuditLogEvent.OAUTH_CONNECTION_SUCCEEDED:
    case AuditLogEvent.OAUTH_CONNECTION_REVOCATION_FAILED:
    case AuditLogEvent.OAUTH_CONNECTION_REVOCATION_SUCCEEDED:
    case AuditLogEvent.OAUTH_CONNECTION_CREDENTIALS_MISSING:
    case AuditLogEvent.ACCOUNT_MAPPINGS_UPDATED:
    case AuditLogEvent.BENEFICIARY_UPDATE:
      return;
    case AuditLogEvent.EMAIL_INVOICE_EXTRACTOR:
    case AuditLogEvent.EMAIL_INVOICE_PROCESSOR:
      // Show extraction progress to users
      if (isError) {
        toast.error(message);
      } else {
        toast.info(message);
      }
      return;
    default:
      return exhaustiveCheck(type);
  }
};
